import { render, staticRenderFns } from "./MedicalMenuList.vue?vue&type=template&id=4e3e85a5&scoped=true&"
import script from "./MedicalMenuList.vue?vue&type=script&lang=ts&"
export * from "./MedicalMenuList.vue?vue&type=script&lang=ts&"
import style0 from "./MedicalMenuList.vue?vue&type=style&index=0&id=4e3e85a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3e85a5",
  null
  
)

export default component.exports